const DEBUG_STORAGE_KEY = 'pm:debug-enabled';
const DEBUG_CHANGED_EVENT = 'pm:debug-changed';

export const isDebugEnabled = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem(DEBUG_STORAGE_KEY) === 'true';
};

export const enableDebug = () => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(DEBUG_STORAGE_KEY, 'true');
  window.dispatchEvent(new Event(DEBUG_CHANGED_EVENT));
};

export const disableDebug = () => {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(DEBUG_STORAGE_KEY);
  window.dispatchEvent(new Event(DEBUG_CHANGED_EVENT));
};

export const toggleDebug = () => {
  if (isDebugEnabled()) {
    disableDebug();
  } else {
    enableDebug();
  }
};

// Native `storage` events don't fire in the tab that wrote the value, so we
// also emit a custom event for in-tab subscribers.
export const subscribeToDebugChanges = (listener: () => void) => {
  if (typeof window === 'undefined') return () => undefined;
  window.addEventListener(DEBUG_CHANGED_EVENT, listener);
  window.addEventListener('storage', listener);
  return () => {
    window.removeEventListener(DEBUG_CHANGED_EVENT, listener);
    window.removeEventListener('storage', listener);
  };
};
